// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EM94mTDKFk2FoOcWbtBC {
  display: inline-flex;
  border: none;
  cursor: auto;
  text-decoration: none;
  position: relative;
  overflow: hidden;
  padding: 0;
}
.EM94mTDKFk2FoOcWbtBC.jiMQLnniHypazsz90Yim {
  border-radius: var(--chip-status-34-border-radius);
  min-height: var(--chip-status-34-height);
}
.EM94mTDKFk2FoOcWbtBC.jiMQLnniHypazsz90Yim .lC5FZmuf2Ufnap_9ciNl {
  border-radius: var(--chip-status-34-border-radius);
  gap: var(--chip-status-34-gap);
  padding: var(--chip-status-34-padding-vertical) var(--chip-status-34-padding-horizontal);
}
.EM94mTDKFk2FoOcWbtBC.jiMQLnniHypazsz90Yim.bELj0rBMJqWM3SPlbxz0 {
  border-radius: var(--chip-status-34-border-radius-icon-only);
}
.EM94mTDKFk2FoOcWbtBC.jiMQLnniHypazsz90Yim.bELj0rBMJqWM3SPlbxz0 .lC5FZmuf2Ufnap_9ciNl {
  border-radius: var(--chip-status-34-border-radius-icon-only);
  padding: var(--chip-status-34-padding-square);
  aspect-ratio: 1/1;
  min-width: var(--chip-status-34-height);
}
.EM94mTDKFk2FoOcWbtBC.xbl2UB2Stst8AUGD_psv {
  background-color: var(--chip-status-info-default-bg);
  color: var(--chip-status-info-default-text);
  border: var(--chip-status-info-default-border, none);
  opacity: var(--chip-status-info-default-opacity, 1);
  box-shadow: var(--chip-status-info-default-shadow, none);
}
.EM94mTDKFk2FoOcWbtBC.xbl2UB2Stst8AUGD_psv .lC5FZmuf2Ufnap_9ciNl {
  background-color: var(--chip-status-info-default-state-bg, transparent);
}
.EM94mTDKFk2FoOcWbtBC.xbl2UB2Stst8AUGD_psv {
  font-family: var(--chip-status-info-default-font-family, inherit);
  font-size: var(--chip-status-info-default-font-size, inherit);
  font-weight: var(--chip-status-info-default-weight, inherit);
}
.EM94mTDKFk2FoOcWbtBC.SH_lmwzZCemGdvMcgCTA {
  background-color: var(--chip-status-error-default-bg);
  color: var(--chip-status-error-default-text);
  border: var(--chip-status-error-default-border, none);
  opacity: var(--chip-status-error-default-opacity, 1);
  box-shadow: var(--chip-status-error-default-shadow, none);
}
.EM94mTDKFk2FoOcWbtBC.SH_lmwzZCemGdvMcgCTA .lC5FZmuf2Ufnap_9ciNl {
  background-color: var(--chip-status-error-default-state-bg, transparent);
}
.EM94mTDKFk2FoOcWbtBC.SH_lmwzZCemGdvMcgCTA {
  font-family: var(--chip-status-error-default-font-family, inherit);
  font-size: var(--chip-status-error-default-font-size, inherit);
  font-weight: var(--chip-status-error-default-weight, inherit);
}
.EM94mTDKFk2FoOcWbtBC.ZHZH6dnaXdM2OiVklYXC {
  background-color: var(--chip-status-warning-default-bg);
  color: var(--chip-status-warning-default-text);
  border: var(--chip-status-warning-default-border, none);
  opacity: var(--chip-status-warning-default-opacity, 1);
  box-shadow: var(--chip-status-warning-default-shadow, none);
}
.EM94mTDKFk2FoOcWbtBC.ZHZH6dnaXdM2OiVklYXC .lC5FZmuf2Ufnap_9ciNl {
  background-color: var(--chip-status-warning-default-state-bg, transparent);
}
.EM94mTDKFk2FoOcWbtBC.ZHZH6dnaXdM2OiVklYXC {
  font-family: var(--chip-status-warning-default-font-family, inherit);
  font-size: var(--chip-status-warning-default-font-size, inherit);
  font-weight: var(--chip-status-warning-default-weight, inherit);
}
.EM94mTDKFk2FoOcWbtBC.kn7gwWUp74GIApHUoIRE {
  background-color: var(--chip-status-success-default-bg);
  color: var(--chip-status-success-default-text);
  border: var(--chip-status-success-default-border, none);
  opacity: var(--chip-status-success-default-opacity, 1);
  box-shadow: var(--chip-status-success-default-shadow, none);
}
.EM94mTDKFk2FoOcWbtBC.kn7gwWUp74GIApHUoIRE .lC5FZmuf2Ufnap_9ciNl {
  background-color: var(--chip-status-success-default-state-bg, transparent);
}
.EM94mTDKFk2FoOcWbtBC.kn7gwWUp74GIApHUoIRE {
  font-family: var(--chip-status-success-default-font-family, inherit);
  font-size: var(--chip-status-success-default-font-size, inherit);
  font-weight: var(--chip-status-success-default-weight, inherit);
}
.EM94mTDKFk2FoOcWbtBC.ZDnmBE1WbY4YkAeCSNfP {
  background-color: var(--chip-status-primary-default-bg);
  color: var(--chip-status-primary-default-text);
  border: var(--chip-status-primary-default-border, none);
  opacity: var(--chip-status-primary-default-opacity, 1);
  box-shadow: var(--chip-status-primary-default-shadow, none);
}
.EM94mTDKFk2FoOcWbtBC.ZDnmBE1WbY4YkAeCSNfP .lC5FZmuf2Ufnap_9ciNl {
  background-color: var(--chip-status-primary-default-state-bg, transparent);
}
.EM94mTDKFk2FoOcWbtBC.ZDnmBE1WbY4YkAeCSNfP {
  font-family: var(--chip-status-primary-default-font-family, inherit);
  font-size: var(--chip-status-primary-default-font-size, inherit);
  font-weight: var(--chip-status-primary-default-weight, inherit);
}
.EM94mTDKFk2FoOcWbtBC .lC5FZmuf2Ufnap_9ciNl {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  width: 100%;
}
.EM94mTDKFk2FoOcWbtBC .lC5FZmuf2Ufnap_9ciNl span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.EM94mTDKFk2FoOcWbtBC .lC5FZmuf2Ufnap_9ciNl svg,
.EM94mTDKFk2FoOcWbtBC .lC5FZmuf2Ufnap_9ciNl i {
  min-height: 1em;
  min-width: 1em;
  flex-shrink: 0;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/UiKit/Chips/ChipStatus/ChipStatus.module.scss"],"names":[],"mappings":"AA8CA;EACE,oBAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;AA7CF;AAgDE;EAnDA,kDAAA;EACA,wCAAA;AAMF;AAJE;EACE,kDAAA;EACA,8BAAA;EACA,wFAAA;AAMJ;AAHE;EACE,4DAAA;AAKJ;AAHI;EACE,4DAAA;EACA,6CAAA;EACA,iBAAA;EACA,uCAAA;AAKN;AAmCE;EA9BA,oDAAA;EACA,2CAAA;EACA,oDAAA;EACA,mDAAA;EACA,wDAAA;AAFF;AAGE;EACE,uEAAA;AADJ;AAyBE;EArBA,iEAAA;EACA,6DAAA;EACA,4DAAA;AADF;AAwBE;EAlCA,qDAAA;EACA,4CAAA;EACA,qDAAA;EACA,oDAAA;EACA,yDAAA;AAaF;AAZE;EACE,wEAAA;AAcJ;AAcE;EAzBA,kEAAA;EACA,8DAAA;EACA,6DAAA;AAcF;AAaE;EAtCA,uDAAA;EACA,8CAAA;EACA,uDAAA;EACA,sDAAA;EACA,2DAAA;AA4BF;AA3BE;EACE,0EAAA;AA6BJ;AAGE;EA7BA,oEAAA;EACA,gEAAA;EACA,+DAAA;AA6BF;AAEE;EA1CA,uDAAA;EACA,8CAAA;EACA,uDAAA;EACA,sDAAA;EACA,2DAAA;AA2CF;AA1CE;EACE,0EAAA;AA4CJ;AARE;EAjCA,oEAAA;EACA,gEAAA;EACA,+DAAA;AA4CF;AATE;EA9CA,uDAAA;EACA,8CAAA;EACA,uDAAA;EACA,sDAAA;EACA,2DAAA;AA0DF;AAzDE;EACE,0EAAA;AA2DJ;AAnBE;EArCA,oEAAA;EACA,gEAAA;EACA,+DAAA;AA2DF;AAnBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;AAqBJ;AAnBI;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAqBN;AAlBI;;EAEE,eAAA;EACA,cAAA;EACA,cAAA;EACA,oBAAA;AAoBN","sourcesContent":["// Миксин для размеров кнопок\n@mixin chip-status-size($size) {\n  $prefix: \"--chip-status-#{$size}\";\n\n  // Базовые свойства для всех кнопок\n  border-radius: var(#{$prefix}-border-radius);\n  min-height: var(#{$prefix}-height);\n\n  .content {\n    border-radius: var(#{$prefix}-border-radius);\n    gap: var(#{$prefix}-gap);\n    padding: var(#{$prefix}-padding-vertical) var(#{$prefix}-padding-horizontal);\n  }\n\n  &.icon-only {\n    border-radius: var(#{$prefix}-border-radius-icon-only);\n\n    .content {\n      border-radius: var(#{$prefix}-border-radius-icon-only);\n      padding: var(#{$prefix}-padding-square);\n      aspect-ratio: 1/1;\n      min-width: var(#{$prefix}-height);\n    }\n  }\n}\n\n// Миксин для цветовых стилей кнопок\n@mixin chip-status-style($type) {\n  $prefix: \"--chip-status-#{$type}\";\n\n  // Базовые стили\n  background-color: var(#{$prefix}-default-bg);\n  color: var(#{$prefix}-default-text);\n  border: var(#{$prefix}-default-border, none);\n  opacity: var(#{$prefix}-default-opacity, 1);\n  box-shadow: var(#{$prefix}-default-shadow, none);\n  .content {\n    background-color: var(#{$prefix}-default-state-bg, transparent);\n  }\n\n  font-family: var(#{$prefix}-default-font-family, inherit);\n  font-size: var(#{$prefix}-default-font-size, inherit);\n  font-weight: var(#{$prefix}-default-weight, inherit);\n}\n\n// Базовый класс кнопки\n.chip-status {\n  display: inline-flex;\n  border: none;\n  cursor: auto;\n  text-decoration: none;\n  position: relative;\n  overflow: hidden;\n  padding: 0;\n\n  // Размеры\n  &.size-34 {\n    @include chip-status-size(\"34\");\n  }\n\n  // Стили кнопок\n  &.info {\n    @include chip-status-style(\"info\");\n  }\n\n  &.error {\n    @include chip-status-style(\"error\");\n  }\n\n  &.warning {\n    @include chip-status-style(\"warning\");\n  }\n\n  &.success {\n    @include chip-status-style(\"success\");\n  }\n\n  &.primary {\n    @include chip-status-style(\"primary\");\n  }\n\n  // Контейнер содержимого кнопки\n  .content {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    width: 100%;\n\n    span {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n\n    svg,\n    i {\n      min-height: 1em;\n      min-width: 1em;\n      flex-shrink: 0;\n      pointer-events: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chip-status": `EM94mTDKFk2FoOcWbtBC`,
	"size-34": `jiMQLnniHypazsz90Yim`,
	"content": `lC5FZmuf2Ufnap_9ciNl`,
	"icon-only": `bELj0rBMJqWM3SPlbxz0`,
	"info": `xbl2UB2Stst8AUGD_psv`,
	"error": `SH_lmwzZCemGdvMcgCTA`,
	"warning": `ZHZH6dnaXdM2OiVklYXC`,
	"success": `kn7gwWUp74GIApHUoIRE`,
	"primary": `ZDnmBE1WbY4YkAeCSNfP`
};
export default ___CSS_LOADER_EXPORT___;
